import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoItIsForSection() {
  return <section className="py-20 px-4 bg-[#0B0E13] text-[#F5F0E8]" data-id="element-364">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-365">
        {/* For You */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-[#1A1F2E] p-8 md:p-10 rounded-2xl border-t-4 border-[#4A8B6E]" data-id="element-366">
          <h3 className="text-2xl font-serif font-bold mb-8 flex items-center" data-id="element-367">
            <span className="bg-[#4A8B6E]/10 p-2 rounded-lg mr-3" data-id="element-368">
              <CheckCircle2 className="w-6 h-6 text-[#4A8B6E]" data-id="element-369" />
            </span>
            Es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-370">
            {['Estás comprando en USA entre $200k–$600k', 'Eres primerizo o repeat buyer y quieres evitar sorpresas', 'Te preocupa EMD, deadlines, cash‑to‑close, CD, HOA docs', 'Quieres claridad sin sentirte “intensa”'].map((item, i) => <li key={i} className="flex items-start" data-id="element-371">
                <CheckCircle2 className="w-5 h-5 text-[#4A8B6E] mr-3 mt-0.5 shrink-0" data-id="element-372" />
                <span className="text-[#F5F0E8]" data-id="element-373">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Not For You */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-[#1A1F2E] p-8 md:p-10 rounded-2xl border-t-4 border-[#C75B3A]" data-id="element-374">
          <h3 className="text-2xl font-serif font-bold mb-8 flex items-center" data-id="element-375">
            <span className="bg-[#C75B3A]/10 p-2 rounded-lg mr-3" data-id="element-376">
              <XCircle className="w-6 h-6 text-[#C75B3A]" data-id="element-377" />
            </span>
            No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-378">
            {['Buscas asesoría legal (esto no reemplaza abogado)', 'Compras 100% cash y no te importan CD/loan timelines', 'Quieres “tips generales”: esto es un sistema ejecutable'].map((item, i) => <li key={i} className="flex items-start" data-id="element-379">
                <XCircle className="w-5 h-5 text-[#C75B3A] mr-3 mt-0.5 shrink-0" data-id="element-380" />
                <span className="text-[#8B8578]" data-id="element-381">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}